import { useState } from 'react';
import { DEFAULT_HEADERS, OPENAI_REALTIME_URL } from '../../../../config';
import { toolClient } from '../../../../services/toolClient';

export const useFeedback = (feedbackPrompt: string, onError: (error: string) => void) => {
  const [feedback, setFeedback] = useState('');
  const [isFeedbackLoading, setIsFeedbackLoading] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);

  const requestFeedback = async (messages: { role: 'user' | 'assistant', text: string }[]) => {
    if (messages.length === 0) {
      onError("No conversation to analyze yet.");
      return;
    }

    setIsFeedbackLoading(true);
    setShowFeedbackModal(true);
    setFeedback('');

    try {
      const conversationText = messages.map(msg => `${msg.role === 'user' ? 'Student' : 'Tally'}: ${msg.text}`).join('\n\n');
      const resp = await toolClient.executeAsyncAndWait<{ feedback: string }>(
        'generate_feedback',
        '1.0.0',
        { conversation_text: `${feedbackPrompt}\n\n${conversationText}` },
        { client: 'web', appVersion: process.env.REACT_APP_VERSION || 'dev' },
        { intervalMs: 1500, timeoutMs: 10 * 60 * 1000 }
      );
      if (!resp.ok || !resp.result?.feedback) throw new Error(resp?.error?.message || 'No feedback content');
      setFeedback(resp.result.feedback);
    } catch (err: any) {
      setFeedback(`Error generating feedback: ${err.message}`);
      onError(`Failed to generate feedback: ${err.message}`);
    } finally {
      setIsFeedbackLoading(false);
    }
  };

  return { feedback, isFeedbackLoading, showFeedbackModal, setShowFeedbackModal, requestFeedback };
};
